const defaultPageSize = 10

module.exports = {
  defaultPageSize
}
